export * from "./mechanical-faults.service";
